import http from '../js/util.http.axios'

const ORIGIN = process.env.NODE_ENV === "development" ? '' : 'https://cvipapi.58.com';
// const ORIGIN = '';

//获取用户昵称和头像（PC端）
function getUserMes() {
	return http.get(ORIGIN + '/ajax/getUserInfo');
}
//获取简历置顶还是亮点简历
//4-黄金标签  5-置顶
//fromtype,来源  可能值：app m pc
function getResumeHighlight(ft,productid) {
	return http.get(ORIGIN + '/ajax/productview?ft='+ft+'&productid='+productid);
}
//用户的求职金卡账户状态
function getCvipinfo(){
	return http.get(ORIGIN + '/ajax/cvipinfo');
}
//开通会员用户的求职金卡首页所需数据
function getCvipMain(ft){
	return http.get(ORIGIN + '/ajax/cvipmain?ft='+ft);
}
//亮点提交
/**
 * @param     {[type]}    type   [消耗类型]4：黄金亮点  5：置顶
 * @param     {[type]}    rid    [选择的简历id]
 * @param     {[type]}    keyid  [时间戳]
 * @param     {[type]}    number [消耗个数]
 * @param     {[type]}    lt     [标签type]
 */
function postHighLight(type,confuseResumeId,keyid,number,lt){
	return http.get(ORIGIN + '/ajax/use?type=' + type + '&rid=' + confuseResumeId + '&keyid=' + keyid + '&number=' + number + '&lt=' +lt );
}
//播报数据
function getVipBroadcast(){
	return http.get(ORIGIN + '/ajax/broadnum');
}
//会员价格/ajax/newV_cvipversion
function getPrice(){
	return http.get(ORIGIN + '/ajax/getVersionList');
}
/**
 * 进入金卡会员页面（首页 & 特权页）
 * @param  from  [来源页面标记统计]
 */
function getEnterCvip(from) {
	return http.get(ORIGIN + '/ajax/enterCvip?from='+from+'&ft=pc');
}
//购买接口
/**
 * @Author    Hybrid
 * @DateTime  2017-09-28
 * @copyright [copyright]
 * @license   [license]
 * @version   [version]
 * @param     {[type]}    state  	[description]
 * @param     {[type]}    vid    	[套餐版本ID0:申请(购买)可不传;3:预约续费]
 * @param     {[type]}    ft     	[来源app,m,pc]
 * @param     {[type]}    from     	[来源页面标记统计]
 * @param     {[type]}    rtnurl 	[成功回跳页面]
 * @param 	  {[type]}	  couponId  [优惠券code 已下线]
 * @return    {[type]}           [description]
 */
function getpaycviporder(state,vid,ft,from,rtnurl,couponId = '', couponCode = ''){
	return http.get(ORIGIN + "/ajax/getpaycviporder?s=" + state + "&vid=" + vid + "&ft=" + ft + "&from=" + from + "&rtnurl=" + rtnurl + "&couponId=" + couponId  + '&couponCode=' + couponCode);
}
//求职保障险首页状态数据
function getinsurance(){
	return http.get(ORIGIN + "/ajax/insurance/");
}
//新版个人意外险获取投保状态
function getAccidentInsuranceState(){
	return http.get(ORIGIN + "/ajax/accidentInsurance");
}
//m端支付接口
function goToMPayCenter(data) {
	let url='//paycenter.58.com/wb/pay?sign='+data.sign+'&merId='+data.merId+'&orderId='+data.orderId+'&accountType='+data.accountType+'&balanceType='+data.balanceType+'&notifyUrl='+data.notifyUrl+'&productName='+data.productName+'&productDesc='+data.productDesc+'&orderMoney='+data.orderMoney+'&IAPProductID='+data.iapproductID+'&starttime='+data.starttime+'&endtime='+data.endtime+'&returnUrl='+data.returnUrl+'&buyAccountId='+data.buyAccountId+'&isBill='+data.isBill+'&platfrom='+data.platFrom+'&payfrom='+data.payFrom+'&extensionInfo='+data.extensionInfo+'&cityId='+data.cityId;
	return http.get(url);
}
// 获取订单状态
function getOrderState(orderId){
	return http.get(ORIGIN + `/ajax/getPayStatus?orderId=${orderId}`);
}
// 获取优惠券数量
function getCouponCount(){
	return http.get(ORIGIN + '/ajax/coupon/getAvailableCouponsSource');
}

// 取消置顶
function cancelResumeTop(resumeId) {
	return http.get(`${ORIGIN}/ajax/cancelResumeTop/${resumeId}`);
}

/**
 * 置顶天数处理
 */
function getResumeTopInfo(resumeId) {
	return http.get(`${ORIGIN}/ajax/getResumeTopInfo/${resumeId}`)
}

export {
	getUserMes,
	getResumeHighlight,
	getCvipinfo,
	getCvipMain,
	postHighLight,
	getVipBroadcast,
	getPrice,
	getpaycviporder,
	getinsurance,
	getAccidentInsuranceState,
	goToMPayCenter,
	getEnterCvip,
	getOrderState,
	cancelResumeTop,
	getResumeTopInfo,
	getCouponCount
};



// WEBPACK FOOTER //
// ./src/api/index.js